import { useState, useEffect } from "react";
import { fetchAccountsMe } from "../api/requests/account-requests";

export const useAccounts = (isOpen, isAdmin) => {
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        if (!isOpen || !isAdmin) {
            setAccounts([]); // Reset if not applicable
            return;
        }

        const fetchUserAccounts = async () => {
            try {
                const res = await fetchAccountsMe();
                const json = await res.json();
                if (res.ok) setAccounts(json.data || []);
            } catch (err) {
                console.error("Accounts fetch error:", err);
            }
        };

        fetchUserAccounts();
    }, [isOpen, isAdmin]);

    return { accounts };
};